import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import HeroSection from './components/HeroSection';
import HotRecommendSection from './components/HotRecommendSection';
import CategorySection from './components/CategorySection';
import LatestUpdateSection from './components/LatestUpdateSection';
import { comics, categories } from '@/mocks/comics';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />

        <div className="w-full px-4 md:px-6 pt-6 md:pt-8">
          <div className="w-full max-w-[1280px] mx-auto">
            <Breadcrumb items={[{ label: '首页', path: '/' }]} />
          </div>
        </div>

        <HotRecommendSection comics={comics} />
        <CategorySection categories={categories} />
        <LatestUpdateSection comics={comics} />

        <section className="w-full px-4 md:px-6 pb-14 md:pb-20 bg-background-100">
          <div className="w-full max-w-[1280px] mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              为什么选择韩漫网？
            </h2>
            <p className="mt-3 text-sm text-foreground-500 mb-10 md:mb-14">数百万用户信赖的韩漫阅读平台</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-database-2-line', title: '海量资源', desc: '超过50,000部韩国漫画，涵盖各种类型' },
                { icon: 'ri-flashlight-line', title: '更新迅速', desc: '每日更新500+话，同步韩国最新连载' },
                { icon: 'ri-shield-check-line', title: '高清画质', desc: '提供高清阅读体验，细节清晰可见' },
                { icon: 'ri-customer-service-2-line', title: '优质服务', desc: '7x24小时客服支持，用心服务每一位读者' },
              ].map((item, i) => (
                <div key={i} className="p-6 rounded-lg bg-background-50">
                  <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mb-4 mx-auto">
                    <i className={`${item.icon} text-xl text-primary-600`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto">
            <div className="bg-primary-500 rounded-lg p-8 md:p-12 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                准备好开始你的韩漫之旅了吗？
              </h2>
              <p className="mt-3 text-sm text-background-50/80 max-w-lg mx-auto">
                现在就加入韩漫网，探索海量优质韩漫资源，享受免费阅读的乐趣！
              </p>
              <a
                href="/category/romance"
                className="mt-6 inline-block px-8 py-3 text-sm font-semibold whitespace-nowrap rounded-md bg-background-50 text-primary-600 hover:bg-background-100 transition-all duration-300 cursor-pointer"
              >
                立即探索
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '韩漫网',
          alternateName: '韩漫免费阅读',
          url: 'http://ryjfh.cn/',
          description: '韩漫免费阅读,韩漫在线,韩国漫画大全-韩漫网站。在这个韩漫网站，您可以免费阅读韩国漫画大全，在线浏览各种作品。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'http://ryjfh.cn/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '韩漫网',
          url: 'http://ryjfh.cn/',
          description: '韩漫网是国内领先的韩国漫画免费阅读平台，提供海量优质韩漫资源。',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'hello@ryjfh.cn',
            telephone: '400-888-6666',
            contactType: 'customer service',
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '韩漫网 - 韩漫免费阅读_韩漫在线_韩国漫画大全',
          description: '韩漫免费阅读,韩漫在线,韩国漫画大全-韩漫网站。在这个韩漫网站，您可以免费阅读韩国漫画大全，在线浏览各种作品。',
          url: 'http://ryjfh.cn/',
          isPartOf: { '@type': 'WebSite', name: '韩漫网', url: 'http://ryjfh.cn/' },
        })}
      </script>
    </>
  );
}